import React from "react";
import { Outlet } from "react-router-dom";
import Box from "@mui/material/Box";
import { tokens as t } from "../theme/tokens";

const EmployeeLayout: React.FC = () => (
  <Box sx={{ minHeight: "100vh", bgcolor: t.color.canvas }}>
    <Box
      component="header"
      sx={{
        height: t.layout.topBarHeight,
        display: "flex",
        alignItems: "center",
        bgcolor: t.color.paper,
        borderBottom: `1px solid ${t.color.cardLine}`,
      }}
    >
      <Box sx={{ width: "100%", maxWidth: t.layout.contentMaxWidth, mx: "auto", px: { xs: 2, sm: 3, lg: 4 } }}>
        <Box
          component="img"
          src="/images/pn_logo_c_rgb-03.png"
          alt="PaperlessNOW"
          sx={{ display: "block", width: 158, height: 46, objectFit: "contain", objectPosition: "left center" }}
        />
      </Box>
    </Box>

    <Box
      component="main"
      sx={{
        width: "100%",
        maxWidth: t.layout.contentMaxWidth,
        mx: "auto",
        px: { xs: 2, sm: 3, lg: 4 },
        py: { xs: 3, sm: 4 },
      }}
    >
      <Outlet />
    </Box>
  </Box>
);

export default EmployeeLayout;
